import { Component, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicFormComponent, License, LicensesService, Client, Group, Course } from '../../core';
import { LicensesQuestionsService } from '../services/licenses-questions.service';

@Component({
  selector: 'lms-license-editor',
  templateUrl: './license-editor.component.html',
  styleUrls: ['./license-editor.component.scss']
})
export class LicenseEditorComponent implements OnInit, OnChanges {
  @Input() public license: License;
  @Input() public defaults: any;
  @Output() public onSave = new EventEmitter<License>();
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  public questions: any[];
  public group: Group;
  public client: Client;
  public course: Course;
  private ready = false;

  constructor(
    public licensesService: LicensesService,
    public licensesQuestions: LicensesQuestionsService,
    public activatedRoute: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe((data) => {
      this.group = data['group'];
      this.client = data['client'];
      this.course = data['course'];
      this.setQuestions();
      this.ready = true;
    });
  }

  ngOnChanges() {
    if (this.ready) {
      this.setQuestions();
    }
  }

  setQuestions() {
    // student form
    this.questions = this.licensesQuestions.getQuestions(this.license, this.course, this.client, this.group);
    this.cd.detectChanges();
  }

  submit(licenseData: any) {
    if (this.license) {
      this.onUpdate(licenseData);
    } else {
      this.onCreate(licenseData);
    }
  }

  onCreate(licenseData: Object) {
    this.licensesService
      .create(Object.assign({}, licenseData, this.defaults))
      .then((license) => {
        this.onSave.emit(license);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  onUpdate(updatedData: Object) {
    const updatedlicense: License = Object.assign({}, this.license, updatedData, this.defaults);
    this.licensesService
      .update(updatedlicense)
      .then((license) => {
        this.onSave.emit(updatedlicense);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }
}
